var GoogleMap = function () {
    var map = undefined;
    var loaded = false; // 是否已经加载
    var circleArray = [];
    var polygonArray = [];
    var polyLineArray = [];
    var markerArray = [];
    var labelArray = [];
    var drawingManager = undefined;

    var EarthRadiusKm = 6378.137; // WGS-84

    function removeElementFromArr(arr, id) {
        if (arr) {
            if (id) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].id == id) {
                        arr[i].overlay.setMap(null);
                        arr.splice(i, 1);
                        break;
                    }
                }
            } else {
                for (i in arr) {
                    arr[i].overlay.setMap(null);
                }
                arr.splice(0, arr.length);
                arr.length = 0;
            }
        }
    }

    /*
      opts = {
        center: [116.404, 39.915], 中心点经纬度
        zoom: 12, 缩放级别
      }
    */
    this.initMap = function (mapId, opts) {
        if (loaded) return;
        if (map != undefined) {
            return;
        }



        if (opts == undefined) {
            opts = {};
        }
        if (opts.center == undefined) {
            opts.center = [116.404, 39.915];// { lat: 39.915, lng: 116.404 };
        }
        if (opts.zoom == undefined) {
            opts.zoom = 14;
        }
        map = new google.maps.Map(document.getElementById(mapId), {
            center: { lat: parseFloat(opts.center[1]), lng: parseFloat(opts.center[0]) },
            zoom: parseInt(opts.zoom),

            disableDefaultUI: false,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_RIGHT,
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
            },
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
            scrollwheel: true
        });



        if (opts.completed) {
            // google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
            opts.completed();
            loaded = true;
            // });
        }




    };
    //绘制多边形
    this.drawPolygon = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        // map.clearOverlays();

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            polygonOptions: {
                strokeColor: color,
                strokeWeight: width,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {

                var paths = event.overlay.getPaths();

                var lonlats = "";
                if (paths.length >= 3) {

                    paths.forEach(path => {
                        path.getArray().forEach(point => {
                            if (lonlats != "") lonlats += ";";
                            lonlats += point.lng() + "," + point.lat();
                        })
                    });
                }
            }
        }); // 监听绘图完成事件


    };
    //绘制矩形
    this.drawRectangle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        // map.clearOverlays();

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            rectangleOptions: {
                strokeColor: color,
                strokeWeight: color,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                const bounds = event.overlay.getBounds();
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();

                if (callback) callback(sw.lng(), sw.lat(), ne.lng(), ne.lat());
            }
        });

    };

    //绘制圆
    this.drawCircle = function (width, color, fillColor, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";
        fillColor = fillColor || "#B3EE3A";
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (fillColor.length != 7) fillColor = "#B3EE3A";

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            circleOptions: {
                strokeColor: color,
                strokeWeight: width,
                fillColor: fillColor,
                fillOpacity: 0.25,
                // editable: true,
                // draggable: true
            }
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                var center = event.overlay.getCenter();
                var radius = event.overlay.getRadius();
                callback(center.lng(), center.lat(), radius);
            }
        });
    };

    //绘制线
    this.drawLine = function (width, color, callback) {
        if (!loaded) return;
        width = width || 2;
        color = color || "#0609D8";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#0609D8";

        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            polylineOptions: {
                strokeColor: color,
                strokeWeight: width,
                // editable: true,
                // draggable: true
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                var path = event.overlay.getPath();
                var lonlats = "";
                path.getArray().forEach(point => {
                    if (lonlats != "") lonlats += ";";

                    lonlats += point.lng() + "," + point.lat();
                })
                if (callback) callback(lonlats);
            }
        });

    };
    //绘制点
    this.drawPoint = function (callback) {
        if (!loaded) return;
        // 初始化绘图管理器
        drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            markerOptions: {
                draggable: false,
                // icon: {
                //     path: google.maps.SymbolPath.CIRCLE,
                //     scale: 8,
                //     strokeColor: '#165DFF',
                //     fillColor: '#165DFF',
                //     fillOpacity: 1.0
                // }
            },
        });
        drawingManager.setMap(map);
        drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
        // 监听绘图完成事件
        google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
            console.log("结束绘制");
            console.log(event);
            drawingManager.setDrawingMode(null);
            if (callback) {
                var p = event.overlay.getPosition();
                callback(p.lng(), p.lat());
            }
        });

    };

    this.setDrawingMode = function (mode) {
        drawingManager.setDrawingMode(mode);

    };

    this.clearAll = function () {
        // 清除所有覆盖物
        circleArray.forEach(item => item.overlay.setMap(null));
        polygonArray.forEach(item => item.overlay.setMap(null));
        polyLineArray.forEach(item => item.overlay.setMap(null));
        markerArray.forEach(item => item.overlay.setMap(null));
        labelArray.forEach(item => item.overlay.setMap(null));

        circleArray = [];
        polygonArray = [];
        polyLineArray = [];
        markerArray = [];
        labelArray = [];
    };

    this.setCenter = function (lng, lat) {
        map.setCenter({ lat: lat, lng: lng });
    };

    // 添加点
    this.addMarker = function (id, name, lng, lat, iconUrl, callback) {
        if (!loaded) return;
        if (lng == undefined || lat == undefined) return false;
        if (id == undefined || id == "") id = "marker0";
        if (name == undefined) name = "marker";

        var icon = undefined;
        if (iconUrl) {
            icon = {
                url: require("@/" + iconUrl),
                scaledSize: new google.maps.Size(22, 32),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 25)
            };
        }

        var position = { lat: lat, lng: lng };
        map.setCenter(position);
        var marker = new google.maps.Marker({
            position: position,
            map: map,
            icon: icon
        });

        if (callback) {
            marker.addListener('click', callback);
        }

        markerArray.push({ id: id, overlay: marker });

        // 添加对应的label
        var label = new google.maps.InfoWindow({
            content: name,
            position: position
        });
        // label.open(map);
        labelArray.push({ id: id, overlay: label });
    };

    // 添加线
    this.addPolyline = function (id, name, coordinators, width, color) {
        if (!loaded) return;
        if (coordinators == undefined || coordinators == "") return false;
        if (id == undefined || id == "") id = "line0";
        if (name == undefined) name = "";
        if (width == undefined || width == "") width = 1;
        if (color == undefined || color == "") color = "#CD3700";
        if (!isNaN(color)) color = "#" + color.toString(16);
        if (color.length != 7) color = "#CD3700";

        var path = coordinators.map(coor => ({
            lat: coor.lat,
            lng: coor.lng
        }));

        var polyline = new google.maps.Polyline({
            path: path,
            geodesic: true,
            strokeColor: color,
            strokeOpacity: 1.0,
            strokeWeight: width,
            map: map
        });

        // 计算适合所有点的视图
        var bounds = new google.maps.LatLngBounds();
        path.forEach(point => bounds.extend(point));
        map.fitBounds(bounds);

        polyLineArray.push({ id: id, overlay: polyline });
    };

    this.removeMarkerById = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray, id);
        removeElementFromArr(labelArray, id);
    };

    this.clearMarkers = function (id) {
        if (!loaded) return;
        removeElementFromArr(markerArray);
        removeElementFromArr(labelArray);
    };

    this.removePolylineById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polyLineArray, id);
    };


    // 添加多边形
    this.addPolygon = function (
        id,
        name,
        coordanites,
        strokeWidth,
        strokeColor,
        fillColor
    ) {
        if (!loaded) return;
        if (coordanites == undefined || coordanites == "") return false;
        if (id == undefined || id == "") id = "region0";
        if (name == undefined) name = "";
        if (strokeWidth == undefined) strokeWidth = 2;
        if (strokeColor == undefined) strokeColor = "#FF0000";
        if (fillColor == undefined) fillColor = "#FF0000";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#FF0000";
        if (fillColor.length != 7) fillColor = "#FF0000";

        var path = coordanites.map(coor => ({
            lat: coor.lat,
            lng: coor.lng
        }));

        var polygon = new google.maps.Polygon({
            paths: path,
            strokeColor: strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: strokeWidth,
            fillColor: fillColor,
            fillOpacity: 0.35,
            map: map
        });

        // 计算适合所有点的视图
        var bounds = new google.maps.LatLngBounds();
        path.forEach(point => bounds.extend(point));
        map.fitBounds(bounds);

        polygonArray.push({ id: id, overlay: polygon });
    };

    // 移除多边形
    this.removePolygonById = function (id) {
        if (!loaded) return;
        removeElementFromArr(polygonArray, id);
    };

    // 清除所有多边形
    this.clearPolygons = function () {
        if (!loaded) return;
        removeElementFromArr(polygonArray);
    };

    // 添加圆形
    this.addCircle = function (id, center, radius, strokeWidth, strokeColor, fillColor) {

        if (!loaded) return;

        if (center == undefined || radius == undefined) return false;
        if (id == undefined || id == "") id = "circle0";

        if (strokeWidth == undefined) strokeWidth = 2;
        if (strokeColor == undefined) strokeColor = "#FF0000";
        if (fillColor == undefined) fillColor = "#FF0000";
        if (!isNaN(strokeColor)) strokeColor = "#" + strokeColor.toString(16);
        if (!isNaN(fillColor)) fillColor = "#" + fillColor.toString(16);
        if (strokeColor.length != 7) strokeColor = "#FF0000";
        if (fillColor.length != 7) fillColor = "#FF0000";

        var circle = new google.maps.Circle({
            strokeColor: strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: strokeWidth,
            fillColor: fillColor,
            fillOpacity: 0.35,
            map: map,
            center: { lat: center.lat, lng: center.lng },
            radius: radius
        });

        // 计算适合圆形的视图
        var bounds = new google.maps.LatLngBounds();
        bounds.extend(circle.getBounds().getNorthEast());
        bounds.extend(circle.getBounds().getSouthWest());
        map.fitBounds(bounds);

        circleArray.push({ id: id, overlay: circle });
    };

    // 移除圆形
    this.removeCircleById = function (id) {
        if (!loaded) return;
        removeElementFromArr(circleArray, id);
    };

    // 清除所有圆形
    this.clearCircles = function () {
        if (!loaded) return;
        removeElementFromArr(circleArray);
    };

    // 可以继续添加其他方法，如添加多边形等，与 BaiduMap 对应
    // ...
};

export { GoogleMap };